import $ from "jquery";

$( () => {
	function toggleHandler(event) {
		if (!event.target.hasAttribute('open')) return;
		let parent = event.target.closest('.accordion, .tabs');
		if (!parent) return;
		let opened = parent.querySelectorAll('details[open]');
		for (let accordion of opened) {
			if (accordion === event.target) continue;
			accordion.removeAttribute('open');
		}
		// window.scrollTo({
		// 	top: window.scrollY + parent.getBoundingClientRect().top - 100,
		// 	behavior: 'smooth', // You can use 'auto' for instant scrolling
		// });
	}
	document.addEventListener('toggle', toggleHandler, true);
});